import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const SocialCoupon = loadable(() => pMinDelay(import('./SocialCoupon'), 300), {
  fallback: <Loading />
});

const AsyncSocialCoupon = props => {
  const metaConfiguration = props.metaConfiguration['/iddaa/kupon'];
  const title = metaConfiguration?.title;
  const description = metaConfiguration.description;
  const meta = metaConfiguration.meta;

  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'mobile-none',
    loadGameListFull: true,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      },
      title,
      description,
      meta
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <SocialCoupon { ...props }/>
    </ApplicationLayout>
  );
};

AsyncSocialCoupon.propTypes = {
  userAgent: PropTypes.object,
  metaConfiguration: PropTypes.object
};

export default AsyncSocialCoupon;
